import script from "./SwitchDivs.vue?vue&type=script&lang=js"
export * from "./SwitchDivs.vue?vue&type=script&lang=js"

import "./SwitchDivs.vue?vue&type=style&index=0&id=5328e806&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5328e806"]])

export default __exports__